<template>
  <div class="modal-content">
    <div class="modal-body">
      <div class="row">
        <div class="col-md-12">
          <h2>{{ _('Payment terminal') }} ({{ terminal }})</h2>
          <h3 v-if="status">{{ statusText }}</h3>
          <h3 v-else>{{ _('Loading...') }}</h3>
          <div class="well" v-if="messages.length">
            {{ lastMessage }}
          </div>
        </div>
      </div>
    </div>
    <div class="modal-footer">
      <button type="button" class="btn btn-warning" v-on:click="abort" :disabled="!canAbort"><i class="fa fa-fw fa-ban"></i>{{ _('Abort') }}</button>
      <button type="button" class="btn btn-default hidden-xs" v-on:click="close"><i class="fa fa-close fa-fw"></i>{{ _('Close') }}</button>
    </div>
  </div>
</template>

<script>
import events from '~/lib/events'

export default {
  mixins: [events],
  props: ['shopId', 'terminal', 'session'],
  data () {
    return {
      status: '',
      statusText: '',
      messages: [],
      doneTimeout: null
    }
  },
  computed: {
    canAbort () {
      return this.status === 'PAY' || this.status === 'CONNECTING'
    },
    lastMessage () {
      if (this.messages && this.messages.length) {
        return this.messages[this.messages.length - 1]
      }
      return null
    }
  },
  methods: {
    close () {
      clearTimeout(this.doneTimeout)
      this.$emit('done')
    },
    abort () {
      this.EventBus.$emit('bamboraCmd', {
        type: 'bamboraCmd', 
        command: 'ABORT',
        shopId: this.shopId,
        terminal: this.terminal,
        session: this.session
      })
      this.doneTimeout = setTimeout(() => { 
        this.$emit('done') 
      }, 5000)
    }
  },
  watch: {
    status: {
      handler (status) {
        if (status === 'CONNECTION_TERMINATED') {
          const paid = this.messages.filter(m => m.match(/maksettu/i) || m.match(/onnistui/i))
          if (paid.length) {
            this.close()
          }
        }
      }
    }
  },
  mounted () {
    if(!this.events) {
      let events = {}
      events['bamboraStatus'] = (message) => {
        if (message.shopId === this.shopId && message.terminal === this.terminal && message.session === this.session) {
          this.status = message.status
          this.statusText = message.text
          this.messages = message.messages
        }
      }
      this.events = events
    }
    this.enableEventBus()
  }
}
</script>